import React from 'react'
import './OnlineUser.css'
import onlineIcon from '../icons/onlineIcon.png';

const OnlineUser = ({element}) => {
  return (
    <div className="roomContainer">
      <div className="leftInnerContainer">
      <img className="onlineIcon" src={onlineIcon} alt="online icon" />
      <h4>{element.name}</h4>
    </div>
    </div>
  )
}

export default OnlineUser